import { render, staticRenderFns } from "./StringFormatter.Regex.vue?vue&type=template&id=b794a8ae&scoped=true"
import script from "./StringFormatter.Regex.vue?vue&type=script&lang=js"
export * from "./StringFormatter.Regex.vue?vue&type=script&lang=js"
import style0 from "./StringFormatter.Regex.vue?vue&type=style&index=0&id=b794a8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b794a8ae",
  null
  
)

export default component.exports